import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { BasicService } from 'src/app/shared/services/basic.service';
import { ModalDismissRoleEnum } from 'src/app/task-process/answer-editor/send-and-popover/modal-dismiss-role.enum';
import { Catalog } from '../catalogs.model';
import { CatalogsService } from '../catalogs.service';
import { ConfirmDeletionComponent } from '../confirm-deletion/confirm-deletion.component';

@Component({
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.scss'],
})
export class CatalogComponent {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private catalogsService: CatalogsService,
    private basicServices: BasicService
  ) {}
  @Input() catalog: Catalog;
  @Input() businessId: number;
  isQueryOngoing = false;

  disconnectCatalog() {
    this.isQueryOngoing = true;
    this.catalogsService.disconnectCatalog(this.businessId, this.catalog.id).subscribe({
      next: redirectUrl => {
        this.document.location.href = redirectUrl;
      },
      complete: () => (this.isQueryOngoing = false),
    });
  }
  async confirmThenDisconnectCatalog() {
    const componentInput = {
      confirmDialogMessageTranslationKey: 'catalog/disconnect/confirm',
    };
    const modalResult = await this.basicServices.popoverWithResult(null, ConfirmDeletionComponent, componentInput);
    if (modalResult.role === ModalDismissRoleEnum.OK) {
      this.disconnectCatalog();
    }
  }
}
